// extracted by mini-css-extract-plugin
export default {"options":"K2dkNDEmH9YWrfYDuDNn","value":"Z85ioMlwEqhHTAbtiKEA"};